module.exports = __webpack_public_path__ + "res/25-img_play.d36e46021717503a92f11db0b4df1cc0.png";